import { createTheme } from "@mui/material/styles";

export const fpColors = {
  fpdarkblue: "#00263A",
  fpgreen: "#44D62C",
  fpgrey: "#A7A8A9",
  fplightblue: "#4E87A0",
  fpyellow: "#FEDD00",
  hyperlinkblue: "#0000EE",
};

// Create a modern theme based on FreightPlus colors with white background
const fpTheme = createTheme({
  palette: {
    mode: "light",
    primary: {
      main: fpColors.fpgreen,
    },
    secondary: {
      main: fpColors.fplightblue,
    },
    background: {
      default: "#FFFFFF",
      paper: "#FFFFFF",
    },
    text: {
      primary: fpColors.fpdarkblue,
      secondary: fpColors.fpgrey,
    },
    warning: {
      main: fpColors.fpyellow,
    },
  },
  typography: {
    fontFamily: '"Roboto", "Segoe UI", "Helvetica Neue", Arial, sans-serif',
    h4: {
      fontWeight: 500,
      color: fpColors.fpdarkblue,
    },
    subtitle1: {
      fontWeight: 500,
    },
    subtitle2: {
      fontWeight: 600,
      fontSize: "0.9rem",
      color: fpColors.fpdarkblue,
    },
  },
  shape: {
    borderRadius: 12,
  },
  components: {
    MuiCard: {
      styleOverrides: {
        root: {
          boxShadow: "0 4px 20px 0 rgba(0, 0, 0, 0.05)",
          border: "1px solid rgba(0, 0, 0, 0.06)",
        },
      },
    },
  },
});

export default fpTheme;
